import React, {useEffect} from "react";
import OrderItem from './OrderItem';
import OrderItemHeader from './OrderItemHeader';
import OrderSummary from './OrderSummary';
import OrderSpedizione from './OrderSpedizione';

function Order(props) {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
/*
  function convert(num) {
    //console.log(num);
    return num.toFixed(2).replace('.',',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    //return num;
  }
*/
  function composeInitialMessage() {
    if (!props.order) return null;
    if (props.order.pagato === "1") {
      return (
        <div className="dettaglio_ordine">
          <h4>L'ordine risulta già pagato.</h4>
        </div>
      );
    } else {
      return (
        <div className="dettaglio_ordine">
          <h3>L'ordine risulta non pagato.</h3>
          <p>
            Utilizza i dati sottostanti per effettuare il pagamento di{" "}
            <strong>{props.convert(props.order.totale)}</strong> &euro;
          </p>
          <p>Metodo di pagamento scelto: {props.order.metodo_pagamento_str}.</p>
          {props.order.id_pagamento === "3" ? (
            <>
              <p>Puoi procedere al pagamento al queste coordinate:</p>
              <br />
              <p>Banca: Solution Bank Spa</p>
              <p>Intestato a: MEDIATOYS srl, Via Marsala 15, 40136 BOLOGNA</p>
              <p>
                IBAN: IT04X0327302400000600102568 (per bonifici dall'estero -
                BIC: CRDRIT2FXXX)
              </p>
              <p>
                Causale bonifico: Saldo ordine n. {props.order.codice_ordine}
              </p>
              <p>Importo: {props.convert(props.order.totale)} &euro;</p>
            </>
          ) : props.order.id_pagamento === "5" ? (
            <>
              <p>
                Il pagamento è eseguibile on-line o direttamente all'ufficio
                postale. Non è richiesta nessuna scheda.
              </p>
              <p>
                In questo caso è necessaria una email o una telefonata per
                permettere di incrociare i dati del pagamento.
              </p>
              <br />
              <p>Carta numero: 4023 6009 5595 7198</p>
              <p>Intestata a: Zabban Guido</p>
              <p>Importo: {props.convert(props.order.totale)} &euro;</p>
            </>
          ) : null}
          
          {props.order.pagato !== "1" && props.paymentUrls !== null ? (
            <p>
              Se preferisci, puoi effettuare il pagamento anche tramite{" "}
              <a href={props.paymentUrls.paypal}>PayPal</a> o{" "}
              <a href={props.paymentUrls.carta_di_credito}>Carta di Credito</a>
              .
            </p>
          ) : null}
        </div>
      );
    }
  }

  function manageItemList() {
    if (props.items != null && props.items.length > 0) {
      return props.items.map((item) => {
              let category = item.detail[0].category.find((el) => el.livello && el.livello === "2");
        if (!category) {
          category = {
            slug: "burago",
            id_category_list: "5",
          }
        }

        return (
        // Without the `key`, React will fire a key warning
        <OrderItem
          key={"oit_" + item.id_e_products}
          item={item}
          urlItem={
            "/" + props.catalogSlug+
            "/" + category.slug +
            "/" + item.detail[0].slug +
            "/" + item.id_e_products
          }          
          urlImg={item.detail[0].images[0].url}
          convert={props.convert}
        />
      )});
    } else {
      return null;
    }
  }

  return (
    <div className="contenitore_ordine">
      <div>
        {props.fullMode === true ? (
          <h1>Dettaglio Ordine N. {props.order.codice_ordine}</h1>
        ) : (
          <h2>Dettaglio Ordine N. {props.order.codice_ordine}</h2>
        )}
      </div>
      <div>{composeInitialMessage()}</div>

      <div>
        <OrderItemHeader />
        {manageItemList()}
      </div>
      <div>
        <OrderSummary order={props.order} convert={props.convert} />
      </div>
      <div>
        <OrderSpedizione order={props.order} />
      </div>
    </div>
  );
}

export default Order;